import React from 'react';
import noop from 'lodash/noop';
import { Flex, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import Panel from '@atlassian/jira-software-backlog-panel/src/common/ui/panel/main.tsx';

const messages = defineMessages({
	title: {
		id: 'software-version-backlog-panel-relay.common.loading-skeleton.title',
		defaultMessage: 'Versions',
		description: 'Backlog version panel title.',
	},
});

export const LoadingSkeleton = () => {
	const { formatMessage } = useIntl();

	return (
		<Panel title={formatMessage(messages.title)} onClose={noop}>
			<Flex alignItems="center" justifyContent="center" xcss={loadingWrapper}>
				<Spinner size="medium" />
			</Flex>
		</Panel>
	);
};

const loadingWrapper = xcss({
	paddingBlock: 'space.600',
});
